import HighlightText from "@/components/ui/highlight-text";
import { cn, formatAmount } from "@/lib/utils";

type SignedAmountProps = {
  amount: number;
  currency: string;
  side: "debit" | "credit";
  originalAmount?: number;
  originalCurrency?: string;
  mark?: string | string[];
};

export const SignedAmount = ({
  amount,
  currency,
  side,
  originalAmount,
  originalCurrency,
  mark,
}: SignedAmountProps) => {
  const isDebit = side === "debit";
  const sign = isDebit ? "-" : "+";

  return (
    <div className="flex flex-col items-end justify-center">
      <p
        className={cn(
          "font-bold font-mono text-right whitespace-nowrap",
          isDebit ? "text-red-500" : "text-emerald-600",
        )}
      >
        {mark ? (
          <HighlightText
            text={`${sign} ${formatAmount(Math.abs(amount), currency ?? "EUR")}`}
            mark={mark}
          />
        ) : (
          `${sign} ${formatAmount(amount, currency ?? "EUR")}`
        )}
      </p>
      {originalAmount && originalCurrency !== currency && (
        <p className="text-xs text-muted-foreground">
          {formatAmount(originalAmount, originalCurrency ?? "")}
        </p>
      )}
    </div>
  );
};
